<template>
  <b-modal v-model="show" centered title="Assign reports review status" hide-footer>
    <div class="d-block mx-2">
      <b-form-select v-model="status" :options="reportSelectStatuses" class="mt-2 mb-4">
        <template #first>
          <b-form-select-option :value="null" disabled>-- Select status --</b-form-select-option>
        </template>
      </b-form-select>
    </div>
    <div class="d-block mx-2">
      <b-form-select v-model="providerStatus" :options="providerStatuses.slice(1)" class="mt-2 mb-4">
        <template #first>
          <b-form-select-option :value="null" disabled>-- Select provider status --</b-form-select-option>
        </template>
      </b-form-select>
    </div>
  </b-modal>
</template>

<script>
import { useReport } from '@/use/report'
import { providerStatuses } from '@/constants/report'

export default {
  emits: ['hideAssignStatusModal', 'clearCheckedReports', 'setReportsStatusDataAfterUpdate'],
  props: {
    showAssignStatusModal: {
      type: Boolean,
      default: false
    },
    checkedReports: {
      default: new Map()
    }
  },
  data: () => {
    return {
      show: false,
      status: '',
      providerStatus: '',
      reportSelectStatuses: [],
      providerStatuses
    }
  },
  watch: {
    showAssignStatusModal() {
      this.show = this.$props.showAssignStatusModal
    },
    show(val) {
      if (!val) {
        this.status = ''
        this.providerStatus = ''
        this.$emit('hideAssignStatusModal')
        this.$emit('clearCheckedReports')
      }
    },
    status(newStatus) {
      if (newStatus) this.assignStatus()
    },
    providerStatus(newStatus) {
      if (newStatus) this.assignStatus('provider')
    }
  },
  setup() {
    const { updateReportStatus, getReportUpdateAvailableStatuses } = useReport()
    return { updateReportStatus, getReportUpdateAvailableStatuses }
  },
  methods: {
    async assignStatus(statusType = 'report') {
      const reportsIds = Array.from(this.checkedReports.keys())
      if (reportsIds.length > 0) {
        let status = this.status
        if (statusType === 'provider') status = this.providerStatus
        if (!status) return
        const resp = await this.updateReportStatus(status, reportsIds, statusType)
        if (resp && resp.result && resp.result === 'success') {
          this.$emit('setReportsStatusDataAfterUpdate', status, reportsIds, statusType)
        }
      }
    }
  },
  mounted() {
    this.reportSelectStatuses = this.getReportUpdateAvailableStatuses()
  }
}
</script>
